<template>
  <div class="share-list-container page-primary">
    <div class="header-box">
      <p>分享列表</p>
    </div>
    <div class="operation-box">
      <div class="common-button-box">
        <el-button
          class="normal-btn"
          v-if="isChecked('Project.Single.Share.Cancel')"
          size="mini"
          @click="batchCancelShare"
          >批量移除</el-button
        >
      </div>
      <div class="filter-box">
        <div class="cascader-box gr24">
          <span class="label-box searchLabel">资源类型：</span>
          <div class="common-select-box">
            <el-cascader
              v-if="showCascader"
              class="primary-select"
              :append-to-body="false"
              size="small"
              popper-class="common-cascader-box"
              v-model="resourceType"
              :options="resourceOptions"
              @change="handleCascaderChange"
              @visible-change="visibleChange"></el-cascader>
          </div>
        </div>
        <div class="common-input-box">
          <el-input
            class="search-input input-primary"
            size="small"
            v-model="keywords"
            placeholder="请输入资源名称"
            clearable
            @clear="search"
            @keyup.enter.native="search">
            <i
              slot="suffix"
              class="el-input__icon el-icon-search"
              @click="search" />
          </el-input>
        </div>
      </div>
    </div>
    <div class="common-table-box">
      <el-table
        :data="shareList"
        class="publish-table"
        highlight-selection-row
        height="100%"
        @select="selectChange"
        @select-all="selectChange"
        @cell-click="handleClick">
        <el-table-column
          type="selection"
          width="60">
        </el-table-column>
        <el-table-column
          label="序号"
          type="index"
          width="55"></el-table-column>
        <el-table-column label="资源名称">
          <template v-slot="{ row }">
            <span
              class="text-overflow resource-name"
              :title="row.resourceName"
              >{{ row.resourceName }}</span
            >
          </template>
        </el-table-column>
        <el-table-column label="分享者">
          <template v-slot="{ row }">
            <span>{{ row.shareUserName }}</span>
          </template>
        </el-table-column>
        <el-table-column label="分享时间">
          <template v-slot="{ row }">
            <span>{{ formatTime(row.limitedTimeBegin) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="到期时间">
          <template v-slot="{ row }">
            <div class="limited-timeend-box">
              <div :class="`circle ${row.limitedTimeEndClass}-bg`"></div>
              <span :class="`${row.limitedTimeEndClass}`">
                {{ row.limitedTimeEnd }}</span
              >
            </div>
          </template>
        </el-table-column>
        <el-table-column label="资源类型">
          <template v-slot="{ row }">
            <span>{{ formatResourceType(row) }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          width="80">
          <template v-slot="{ row }">
            <div class="operation-cell">
              <el-button
                size="small"
                type="text"
                @click="cancelShareById(row)"
                >移除</el-button
              >
            </div>
          </template>
        </el-table-column>
        <template slot="empty">
          <div class="common-empty-box">
            <bj-empty
              :image="require('@/assets/img/no-data.png')"
              class="empty-page">
              <template slot="description">
                <div class="empty-text">抱歉，没有找到相关内容</div>
              </template>
            </bj-empty>
          </div>
        </template>
      </el-table>
    </div>
  </div>
</template>

<script>
import { Store } from '@/utils/store'
import { formatTime } from '@/utils/generalMethods'

import {
  getUserNameList,
  qureySharedProjectService,
  generateUser,
  removeOtherShareService
} from '@/service/interface'

export default {
  data() {
    return {
      keywords: '',
      resourceType: ['all'],
      resourceOptions: [
        { value: 'all', label: '所有' },
        {
          value: 'dataSet',
          label: '数据集',
          children: [
            { value: 'all', label: '全部' },
            { value: 1, label: '模型' },
            { value: 2, label: '模型组' },
            { value: 3, label: '遥感影像' },
            { value: 4, label: 'Wmts' },
            { value: 5, label: '倾斜摄影' },
            { value: 6, label: '360全景图' },
            { value: 7, label: '点云' },
            { value: 8, label: '二维图纸' },
            { value: 9, label: '矢量' }
          ]
        },
        { value: 0, label: '场景' }
      ],
      shareList: [],
      selectShares: [],
      showCascader: true
    }
  },
  mounted() {
    this.initShareList()
  },
  methods: {
    initShareList() {
      this.queryShareList().then(shareList => {
        this.shareList = shareList
      })
    },
    handleCascaderChange(value) {
      this.filterByResourceType(value).then(shareList => {
        this.shareList = shareList
      })
    },
    visibleChange(flag) {
      if (flag) return
      this.showCascader = false
      this.$nextTick(() => {
        this.showCascader = true
      })
    },
    search() {
      this.filterByResourceType(this.resourceType).then(shareList => {
        shareList = shareList.filter(el =>
          el.resourceName.includes(this.keywords)
        )
        this.shareList = shareList
      })
    },
    queryShareList() {
      return new Promise(resolve => {
        let projId = this.$route.params.projId
        qureySharedProjectService(projId).then(response => {
          if (response.isSuccess) {
            let data = response.data
            let dataSets = data.sharedDataSets
            let scenes = data.sharedScenes
            let shareList = [...dataSets, ...scenes]
            let creatorIds = this.getCreatorIds(shareList)
            this.getSharerNames(creatorIds).then(sharerNames => {
              shareList = this.formatShareList(shareList, sharerNames)
              resolve(shareList)
            })
          }
        })
      })
    },
    handleClick(resourceInfo, column) {
      if (column.label !== '资源名称') return

      let pageUrl = ''
      let resourceType = resourceInfo.resourceType
      if (resourceType === 0) {
        pageUrl = 'sceneShare/view'
      } else {
        pageUrl = 'dataSetShare/view'
      }
      let params = {
        userId: resourceInfo.shareToUserId,
        sceneId: resourceInfo.resourceId
      }
      generateUser(params).then(response => {
        if (response.isSuccess) {
          let data = response.data
          if (data) {
            let url = ''
            if (resourceType === 0) {
              url = `${window.location.origin}${window.location.pathname}#/${pageUrl}/${resourceInfo.shareId}/${resourceInfo.resourceId}?viewMode=${resourceInfo.displayMode}&token=${resourceInfo.shareToToken}`
            } else {
              let dataType = this.getDataType(resourceInfo.resourceSubType)
              url = `${window.location.origin}${window.location.pathname}#/${pageUrl}/${resourceInfo.shareId}/${resourceInfo.resourceId}?dataType=${dataType}&token=${resourceInfo.shareToToken}`
            }

            window.open(url, '_blank')
          }
        }
      })
    },
    cancelShareById(shareInfo) {
      let params = {
        shareIds: [shareInfo.shareId]
      }
      removeOtherShareService(params).then(response => {
        if (response.isSuccess) {
          this.queryShareList().then(shareList => {
            this.$message.success('取消分享成功！！！')
            this.selectScenes = []
            this.shareList = shareList
          })
        } else {
          this.$message.error(response.errMsg)
        }
      })
    },
    batchCancelShare() {
      if (!this.selectShares.length) {
        this.$message.warning('请先选择需要取消分享的资源！')
        return
      }
      let shareIds = this.selectShares.map(el => el.shareId)
      let params = { shareIds }
      removeOtherShareService(params).then(response => {
        if (response.isSuccess) {
          this.queryShareList().then(shareList => {
            this.$message.success('取消分享成功！！！')
            this.selectScenes = []
            this.shareList = shareList
          })
        } else {
          this.$message.error(response.errMsg)
        }
      })
    },
    filterByResourceType(resourceType) {
      return new Promise(resolve => {
        this.queryShareList().then(shareList => {
          if (resourceType.length === 1) {
            if (resourceType[0] === 'all') {
              resolve(shareList)
            }
            if (resourceType[0] === 0) {
              shareList = shareList.filter(el => el.resourceType === 0)
              resolve(shareList)
            }
          }
          if (resourceType.length === 2) {
            let resourceSubType = resourceType[1]
            if (resourceSubType === 'all') {
              shareList = shareList.filter(el => el.resourceType === 2)
              resolve(shareList)
            } else {
              shareList = shareList.filter(
                el => el.resourceSubType === resourceSubType
              )
              resolve(shareList)
            }
          }
        })
      })
    },
    /**
     * 根据creatorIds获取分享者名称
     */
    getSharerNames(creatorIds) {
      return new Promise(resolve => {
        let params = {
          resultCount: 1000,
          skipCount: 0,
          userIds: creatorIds,
          searchType: '',
          filter: ''
        }
        getUserNameList(params).then(response => {
          if (response.status === 200) {
            let res = response.data
            if (res.isSuccess) {
              let sharerNames = res.data.items
              resolve(sharerNames)
            }
          }
        })
      })
    },
    selectChange(selection) {
      this.selectShares = selection
    },
    formatShareList(shareList, sharerNames) {
      shareList = shareList.map(item => {
        let find = sharerNames.find(el => el.userId === item.creatorId)
        let obj = {
          shareId: item.shareId,
          resourceId: item.resourceId,
          resourceName: item.resourceName,
          shareUserName: find.surname,
          limitedTimeBegin: item.limitedTimeBegin,
          limitedTimeEnd: this.getLimitedTimeEnd(item),
          limitedTimeEndClass: this.getLimitedTimeEndClass(item),
          resourceType: item.resourceType,
          resourceSubType: item.resourceSubType,
          shareType: item.shareType,
          shareToUserId: item.shareToUserId,
          shareToToken: item.shareToToken,
          displayMode: item.displayMode
        }
        return obj
      })
      return shareList
    },
    getCreatorIds(shareList) {
      let creatorIds = []
      shareList.forEach(item => {
        let find = creatorIds.find(el => el === item.creatorId)
        if (!find) {
          creatorIds.push(item.creatorId)
        }
      })
      return creatorIds
    },
    getLimitedTimeEnd(item) {
      let limitedTime = item.limitedTime

      let currentTime = new Date().getTime()
      let endTime = new Date(Date.parse(item.limitedTimeEnd)).getTime()

      if (limitedTime === 4) {
        return '永久有效'
      }

      if (currentTime - endTime > 0) {
        return '已过期'
      }

      return this.formatTime(item.limitedTimeEnd)
    },
    getLimitedTimeEndClass(item) {
      let limitedTime = item.limitedTime

      let currentTime = new Date().getTime()
      let endTime = new Date(Date.parse(item.limitedTimeEnd)).getTime()

      if (limitedTime === 4) {
        return 'forever'
      }

      if (currentTime - endTime > 0) {
        return 'overtime'
      }

      return 'normal'
    },
    getDataType(resourceSubType) {
      let dataTypeArray = [
        { value: 1, label: 'Bim' },
        { value: 2, label: 'Bim' },
        { value: 3, label: 'Rs' },
        { value: 4, label: 'Wmts' },
        { value: 5, label: 'Osgb' },
        { value: 6, label: 'Panorama' },
        { value: 7, label: 'PointCloud' },
        { value: 8, label: 'Cad' },
        { value: 9, label: 'Vector' }
      ]
      let find = dataTypeArray.find(el => el.value === resourceSubType)
      return find.label
    },
    formatResourceType(shareInfo) {
      const dataTypeMap = [
        '场景',
        '模型',
        '模型组',
        '遥感影像',
        'WMTS地图服务',
        '倾斜摄影',
        '360全景图',
        '点云',
        '二维图纸',
        '矢量'
      ]

      let { resourceType, resourceSubType } = shareInfo
      if (resourceType === 0) {
        return dataTypeMap[0]
      } else {
        return dataTypeMap[resourceSubType]
      }
    },
    /**
     * 权限验证
     */
    isChecked(permissionCode) {
      let permissionData = Store.permissionData
      let find = permissionData.find(el => el.permissionCode === permissionCode)
      return find.isCheck
    },
    formatTime
  }
}
</script>

<style lang="less" scoped>
@import '@/assets/css/publishSearch.less';
@import '@/assets/css/pageStyle.less';
.share-list-container {
  max-width: 100% !important;
  flex: 1;
  margin-bottom: 16px;
  .header-box {
    height: 20px;
    text-align: left;
    border-left: 4px solid var(--base-primary-bgColor);

    p {
      line-height: 20px;
      margin-left: 10px;
    }
  }

  .operation-box {
    display: flex;
    justify-content: space-between;
    margin: 16px 0;

    .common-button-box {
      margin: auto 0px;
      .el-button--default {
        height: unset;
      }
    }

    .filter-box {
      display: flex;
      .cascader-box {
        display: flex;
        .label-box {
          line-height: 32px;
        }
      }

      .common-input-box {
        margin-left: 10px;
      }
    }
  }

  .common-table-box {
    height: calc(100% - 80px);

    .resource-name {
      cursor: pointer;
      &:hover {
        color: var(--primary-color);
        text-decoration: underline;
      }
    }

    .limited-timeend-box {
      display: flex;
      .circle {
        width: 5px;
        height: 5px;
        margin: auto 10px auto 0px;
        border-radius: 50%;
      }

      .normal {
        color: var(--runing-status-color);
      }

      .normal-bg {
        background-color: var(--runing-status-color);
      }

      .overtime {
        color: var(--status-color5);
      }

      .overtime-bg {
        background-color: var(--status-color5);
      }

      .forever {
        color: var(--success-status-color);
      }

      .forever-bg {
        background-color: var(--success-status-color);
      }
    }
  }
}
</style>
